var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.wrapper},[_c('div',{class:_vm.$style.container,attrs:{"v-if":_vm.studioInfos.hubspotUrl}},[_c('HubSpotButton',{attrs:{"size":40,"url":_vm.studioInfos.hubspotUrl}}),_c('span',{class:_vm.$style.label},[_vm._v("Hubspot")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }